export const ampmTimeDisabler = (type) => {
  const hours = []
  if (type === 'pm') {
    for (var i = 0; i <= 12; i++) {
      hours.push(i)
    }
  } else {
    for (var j = 12; j <= 24; j++) {
      hours.push(j)
    }
  }

  return { disabledHours: () => hours }
}
